import { Product } from 'common/types/entities/api/product'

export enum NaverPayDeliveryFeeType {
  PRE_PAY = 'PRE_PAY',
  AFTER_PAY = 'AFTER_PAY',
}

export enum NaverPayDeliveryType {
  NOTHING = 'NOTHING',
  DELIVERY = 'DELIVERY',
  DIRECT_DELIVERY = 'DIRECT_DELIVERY',
  VISIT_RECEIPT = 'VISIT_RECEIPT',
  QUICK_SVC = 'QUICK_SVC',
}

export enum NaverPayOrderErrorCode {
  ADULT_ONLY_PURCHASE = 'ADULT_ONLY_PURCHASE',
  CART_ITEM_COUNT = 'CART_ITEM_COUNT',
  CART_RESTRICT = 'CART_RESTRICT',
  SUBSCRIPTION = 'SUBSCRIPTION',
  MAX_PURCHASE_QUANTITY = 'MAX_PURCHASE_QUANTITY',
  MIN_PURCHASE_QUANTITY = 'MIN_PURCHASE_QUANTITY',
  EXCESS_USER_PURCHASE_QUANTITY = 'EXCESS_USER_PURCHASE_QUANTITY',
  EXHAUSTED_USER_PURCHASE_QUANTITY = 'EXHAUSTED_USER_PURCHASE_QUANTITY',
  PRODUCT_TYPE = 'PRODUCT_TYPE',
  PRODUCT_STATUS = 'PRODUCT_STATUS',
  PRODUCT_STOCK_QUANTITY = 'PRODUCT_STOCK_QUANTITY',
  PRODUCT_PRICE = 'PRODUCT_PRICE',
  DELIVERY_METHOD = 'DELIVERY_METHOD',
  IMMEDIATE_DISCOUNT = 'IMMEDIATE_DISCOUNT',
  OPTION_STATUS = 'OPTION_STATUS',
  SUPPLEMENT_STATUS = 'SUPPLEMENT_STATUS',
  OPTION_STOCK_QUANTITY = 'OPTION_STOCK_QUANTITY',
  SUPPLEMENT_STOCK_QUANTITY = 'SUPPLEMENT_STOCK_QUANTITY',
  OPTION_PRICE = 'OPTION_PRICE',
  SUPPLEMENT_PRICE = 'SUPPLEMENT_PRICE',
  OPTION_INFO = 'OPTION_INFO',
  SUPPLEMENT_INFO = 'SUPPLEMENT_INFO',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export enum NaverPayServiceType {
  NAVERPAY = '네이버페이',
  SMARTSTORE = '스마트스토어',
}

export enum GradeStatus {
  NONE = 'NONE',
  EXPCT_MEMBER = 'EXPCT_MEMBER',
  PLUS_MEMBER = 'PLUS_MEMBER',
  EXPCT_PLUS_MEMBER = 'EXPCT_PLUS_MEMBER',
}

export const MY_PAY_DEFAULT_VALUE = '-'

namespace NaverPayOrderError {
  const naverPayOrderError = {
    ADULT_ONLY_PURCHASE: { template: () => '19세 미만은 구매가 불가능한 상품입니다.' },
    CART_ITEM_COUNT: {
      template: ({ CART_ADD_LIMIT }) =>
        `장바구니에는 상품을 최대 ${CART_ADD_LIMIT}개까지만 등록하실 수 있습니다. 장바구니 상품을 주문 또는 삭제하신 후에 진행해 주십시오.`,
    },
    CART_RESTRICT: {
      template: ({ targetProduct }) =>
        `${(targetProduct && targetProduct.name) || '이'} 상품은 장바구니 구매를 하실 수 없습니다.`,
    },
    BLACKCONSUMER: {
      template: ({ targetProduct }) => {
        const store = targetProduct.ssChannel
        if (store.domesticTelephoneNumberReported) {
          return `회원님은 해당 판매자의 상품 구매가 불가합니다.\n자세한 사항은 상품 Q&A를 통해\n판매자에게 문의하여 주시기 바랍니다.`
        }
        const telephoneNumber =
          (store.contactInfo.telNo && store.contactInfo.telNo.formattedNumber) ||
          (store.contactInfo.overseaTelNo && store.contactInfo.overseaTelNo.formattedNumber)
        return `회원님은 해당 판매자의 상품 구매가 불가합니다.\n자세한 사항은 판매자에게 문의하여 주시기 바랍니다.\n${
          store.channelName
        } (${telephoneNumber})\n`
      },
    },
    SUBSCRIPTION: {
      template: ({ targetProduct }) =>
        `${(targetProduct && targetProduct.name) || '이'} 상품은 스토어찜 회원만 구매 할 수 있는 상품입니다.`,
    },
    MAX_PURCHASE_QUANTITY: {
      template: ({ MAX_PURCHASE_LIMIT, targetProduct }) =>
        `${(targetProduct && targetProduct.name) ||
          '이'} 상품은 ${MAX_PURCHASE_LIMIT}개 이하로 구매하실 수 있습니다. ${MAX_PURCHASE_LIMIT}개 이하로 구매해주세요.`,
    },
    MIN_PURCHASE_QUANTITY: {
      template: ({ MIN_PURCHASE_LIMIT, targetProduct }) =>
        `${(targetProduct && targetProduct.name) ||
          '이'} 상품은 ${MIN_PURCHASE_LIMIT}개 이상부터 구매하실 수 있습니다. ${MIN_PURCHASE_LIMIT}개 이상 구매해주세요.`,
    },
    EXCESS_USER_PURCHASE_QUANTITY: {
      template: ({ USER_PURCHASE_LIMIT, targetProduct }) =>
        `${(targetProduct && targetProduct.name) ||
          '이'} 상품은 ${USER_PURCHASE_LIMIT}개 이하로 구매하실 수 있습니다. ${USER_PURCHASE_LIMIT}개 이하로 구매해주세요.`,
    },
    EXHAUSTED_USER_PURCHASE_QUANTITY: {
      template: ({ targetProduct }) =>
        `${(targetProduct && targetProduct.name) ||
          '이'} 상품의 최대 구매수량을 이미 구매하셨으므로 더이상 구매하실 수 없습니다.`,
    },
    PRODUCT_TYPE: {
      template: ({ USER_PURCHASE_LIMIT }) => `옵션정보가 ${USER_PURCHASE_LIMIT}되었습니다. 다시 주문해 주세요`,
    },
    PRODUCT_STATUS: {
      template: ({ targetProduct }) =>
        `${(targetProduct && targetProduct.name) || '이'} 상품은 구매 하실 수 없는 상품입니다.`,
    },
    PRODUCT_STOCK_QUANTITY: {
      template: ({ targetProduct, PRODUCT_STOCK_QUANTITY }) =>
        `${(targetProduct && targetProduct.name) ||
          '이'} 상품의 재고가 부족합니다.\n${PRODUCT_STOCK_QUANTITY}개 이하로 구매해주세요.`,
    },
    PRODUCT_PRICE: {
      template: ({ targetProduct }) =>
        `${(targetProduct && targetProduct.name) || '이'} 상품의 가격이 변경 되었습니다. 다시 주문해주세요.`,
    },
    DELIVERY_METHOD: {
      template: ({ targetProduct }) =>
        `${(targetProduct && targetProduct.name) || '이'} 상품의 배송방법이 변경되었습니다. 다시 주문해 주세요.`,
    },
    IMMEDIATE_DISCOUNT: {
      template: ({ targetProduct }) =>
        `${(targetProduct && targetProduct.name) || '이'} 상품의 즉시할인 금액이 변경되었습니다. 다시 주문해주세요.`,
    },
    OPTION_STATUS: { template: () => '선택하신 옵션이 변경되었습니다. 다시 주문해주세요.' },
    SUPPLEMENT_STATUS: { template: () => '선택하신 추가상품이 변경되었습니다. 다시 주문해주세요.' },
    OPTION_STOCK_QUANTITY: {
      template: ({ ITEM_CONTENT_NAMES, ITEM_STOCK_QUANTITY }) =>
        `${ITEM_CONTENT_NAMES}의 재고가 부족합니다.\n${ITEM_STOCK_QUANTITY}개 이하로 구매해 주세요.`,
    },
    SUPPLEMENT_STOCK_QUANTITY: {
      template: ({ ITEM_CONTENT_NAMES, ITEM_STOCK_QUANTITY }) =>
        `${ITEM_CONTENT_NAMES}의 재고가 부족합니다.\n${ITEM_STOCK_QUANTITY}개 이하로 구매해 주세요.`,
    },
    OPTION_PRICE: {
      template: ({ ITEM_CONTENT_NAMES }) => `${ITEM_CONTENT_NAMES}의 가격이 변경 되었습니다. 다시 주문해주세요.`,
    },
    SUPPLEMENT_PRICE: {
      template: ({ ITEM_CONTENT_NAMES }) => `${ITEM_CONTENT_NAMES}의 가격이 변경 되었습니다. 다시 주문해주세요.`,
    },
    OPTION_INFO: { template: () => '선택하신 옵션이 변경되었습니다. 다시 주문해주세요.' },
    SUPPLEMENT_INFO: { template: () => '선택하신 추가상품이 변경되었습니다. 다시 주문해주세요.' },
    UNEXPECTED_ERROR: { template: () => '잠시 후 다시 시도해주세요.' },
  }

  export const getOrderErrorMessage = (orderError: any, targetProduct?: Product) => {
    let template
    if (!orderError || !orderError.errorCode) {
      template = naverPayOrderError.UNEXPECTED_ERROR.template
    } else {
      template = naverPayOrderError[orderError.errorCode].template
    }

    const templateData = (orderError && orderError.errorArguments) || {}

    return template({ ...templateData, targetProduct })
  }

  export const alertOrderError = (orderResult, orderProducts?: Product[]) => {
    let firstError = null
    if (orderResult) {
      firstError = orderResult.errors && orderResult.errors[0]
    }

    let targetProduct
    if (orderProducts && orderProducts.length) {
      targetProduct = orderProducts.find(product => product.id.toString() === firstError.productId)
    }

    const errorDescription = getOrderErrorMessage(firstError, targetProduct)
    alert(errorDescription)
  }
}

export default NaverPayOrderError
